const server = 'https://api.mansolutions.app'
const port = 443
const domain = 'admin.mansolutions.app'
// const server = 'http://localhost'
// const port = 9004
// const domain = 'localhost'
export { server, port, domain }
